import React from 'react';
import styled, { css } from 'styled-components';
import { getResponsiveType } from '../utils';
import { Typography } from './Typography';

interface TrustpilotStarsProps {
  showReviewCount?: boolean;
  rating: number; // Rating between 4 and 5 (e.g., 4.0, 4.5, 5.0)
  inverse?: boolean; // Turn Google logo white
  url: string; // URL to Trustpilot reviews
  totalReviews?: number;
}

// Styles

const StyledTrustpilotStars = styled.a`
  ${({ theme: { space, media } }) => css`
    ${getResponsiveType('titleExtraSmall')}
    display: flex;
    flex-wrap: wrap;
    gap: ${space.sm};
    flex-direction: column;
    text-decoration: none;

    svg {
      height: 24px;
    }

    @media (min-width: ${media.sm}) {
      flex-direction: row;
      gap: ${space.md};
    }
  `};
`;

const StyledLogo = styled.div`
  ${({ theme: { space } }) => css`
    display: flex;
    gap: ${space.md};
    align-items: center;
  `};
`;

const TrustPilotLogo = ({ inverse }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 98 24">
    <path
      fill={inverse ? '#fff' : '#111'}
      d="M75.978 10.352h1.953V8.504h-1.953v1.848Zm0 10.378h1.953v-8.85h-1.953v8.85Zm3.697 0h1.954V8.506h-1.954V20.73Zm17.777-1.45c-.139.01-.276.01-.413.01-.226 0-.39-.027-.518-.078a.56.56 0 0 1-.285-.233.973.973 0 0 1-.123-.38 4.822 4.822 0 0 1-.025-.535v-4.728h1.762V11.88h-1.762V9.224h-1.952v2.655h-1.46v1.475h1.477v5.22c.007.363.053.69.113.975.069.284.18.517.363.705.172.19.422.337.734.432.31.096.725.149 1.243.149.218 0 .424-.01.63-.036.199-.024.415-.042.632-.07v-1.51c-.14.035-.277.053-.416.06ZM72.41 17.453c-.08.354-.226.69-.43.99-.2.287-.45.528-.762.71-.31.18-.681.275-1.13.275-.398 0-.753-.077-1.054-.241a2.319 2.319 0 0 1-.779-.648 2.748 2.748 0 0 1-.49-.984 4.338 4.338 0 0 1-.164-1.241c0-.95.206-1.71.621-2.28.414-.566 1.035-.852 1.856-.852.397 0 .753.095 1.063.268.303.173.561.406.77.698.207.295.362.623.466 1.002.103.38.156.767.156 1.164 0 .388-.045.767-.123 1.14v-.001Zm1.046-4.435a3.574 3.574 0 0 0-1.296-1.01c-.517-.247-1.123-.371-1.822-.371a3.8 3.8 0 0 0-1.598.337c-.493.226-.872.587-1.15 1.106h-.033v-1.2h-1.849V24h1.952v-4.418h.036c.155.233.336.44.56.623.216.18.466.326.727.44.257.112.535.197.82.25.285.05.57.077.855.077.655 0 1.217-.13 1.703-.388a3.43 3.43 0 0 0 1.19-1.028c.311-.43.544-.922.7-1.483.155-.552.233-1.13.233-1.725a6.29 6.29 0 0 0-.259-1.83 4.4 4.4 0 0 0-.77-1.501h.001Zm16.534 4.417c-.104.373-.25.71-.458 1.002a2.416 2.416 0 0 1-.787.716c-.32.18-.7.275-1.13.275-.433 0-.813-.086-1.132-.275a2.416 2.416 0 0 1-.787-.716 3.044 3.044 0 0 1-.458-1.002 4.568 4.568 0 0 1-.146-1.137c0-.38.051-.751.146-1.13a3.16 3.16 0 0 1 .458-1.002c.208-.29.477-.53.787-.707.347-.19.737-.285 1.132-.277.43 0 .81.095 1.13.277.32.18.58.414.787.707.208.294.363.62.458 1.002.095.379.146.75.146 1.13 0 .386-.051.767-.146 1.137Zm.924-4.477a4.204 4.204 0 0 0-1.408-.966 4.866 4.866 0 0 0-1.891-.355c-.71 0-1.34.124-1.893.355a3.974 3.974 0 0 0-1.408.966c-.39.427-.686.93-.873 1.476-.204.6-.306 1.23-.301 1.864 0 .68.104 1.31.301 1.878.199.572.493 1.064.873 1.476.387.406.856.734 1.408.967.553.232 1.184.354 1.893.354.708 0 1.338-.122 1.89-.354a3.975 3.975 0 0 0 1.409-.967c.379-.412.674-.904.871-1.476.206-.604.309-1.24.303-1.878 0-.674-.104-1.296-.303-1.864a4.21 4.21 0 0 0-.871-1.476ZM35.622 8.506h-9.916v1.846h3.878V20.73h2.142V10.352h3.896V8.506Zm4.025 3.13c-.293 0-.588.062-.872.175-.549.225-1.024.599-1.373 1.079a1.963 1.963 0 0 0-.338.697h-.035v-1.708h-1.84v8.843h1.953V16.51c0-.49.061-.922.19-1.301.13-.38.302-.69.519-.95.216-.25.466-.45.76-.577.293-.13.604-.198.933-.198.138 0 .275.007.423.025.148.018.285.035.423.062v-1.882c-.096-.007-.18-.025-.268-.035a5.882 5.882 0 0 0-.475-.018Zm23.868 7.654c-.226 0-.39-.027-.518-.078a.572.572 0 0 1-.287-.233 1.001 1.001 0 0 1-.121-.38 5.27 5.27 0 0 1-.025-.535v-4.728h1.762V11.88h-1.762V9.224h-1.952v2.655h-1.46v1.475h1.477v5.22c.007.363.053.69.113.975.069.284.18.517.363.705.172.19.422.337.734.432.31.096.725.149 1.243.149.216 0 .422-.01.63-.036.2-.024.415-.042.63-.07v-1.51a2.362 2.362 0 0 1-.414.06c-.139.01-.276.01-.413.01Zm-16.103-2.27c0 .346-.034.665-.111.958a1.967 1.967 0 0 1-.371.76 1.74 1.74 0 0 1-.666.508c-.276.13-.614.19-1.028.19-.535 0-.96-.164-1.253-.483-.301-.32-.448-.871-.448-1.647v-5.427h-1.954v5.615c0 1.166.26 2.037.778 2.616.518.576 1.367.862 2.53.862a2.92 2.92 0 0 0 1.453-.406c.475-.266.829-.62 1.07-1.07h.035v1.234h1.919v-8.842h-1.954v5.132Zm10.307-.74a3.158 3.158 0 0 0-.917-.468 11.21 11.21 0 0 0-1.046-.293c-.362-.077-.714-.155-1.061-.224a6.45 6.45 0 0 1-.916-.25 2.108 2.108 0 0 1-.647-.37.736.736 0 0 1-.25-.58.67.67 0 0 1 .172-.473c.12-.12.259-.215.423-.275.172-.06.346-.106.535-.13.19-.025.354-.036.493-.036.431 0 .82.078 1.156.243.338.154.546.475.64.94h2.038c-.06-.492-.197-.915-.423-1.26a2.818 2.818 0 0 0-.838-.845 3.354 3.354 0 0 0-1.132-.475 5.866 5.866 0 0 0-1.313-.148c-.396 0-.82.046-1.26.124-.44.084-.838.224-1.2.42-.355.2-.658.458-.89.788-.234.326-.356.723-.356 1.206 0 .448.078.82.243 1.12.155.303.37.553.64.744.269.2.57.352.906.465.338.113.692.216 1.055.293.353.078.7.157 1.045.224.345.07.648.155.916.25.267.105.482.224.656.388a.836.836 0 0 1 .277.612c.009.253-.053.45-.182.605-.137.16-.313.281-.51.355a2.654 2.654 0 0 1-.657.164 6.082 6.082 0 0 1-.621.042c-.527 0-.977-.12-1.356-.344-.373-.234-.588-.631-.648-1.2v.017h-1.97c.016.527.122.984.32 1.363.2.38.474.698.82.958.346.25.76.439 1.235.57.476.128.995.188 1.555.188.467 0 .933-.052 1.39-.153.45-.1.882-.27 1.28-.503.38-.222.69-.524.933-.887.242-.37.363-.811.363-1.337 0-.432-.088-.802-.25-1.095a2.295 2.295 0 0 0-.648-.734Z"
    />
    <path
      fill="#00B67A"
      d="M8.948 8.505 0 8.497l7.246 5.264-2.773 8.496 7.248-5.253 7.239 5.253-2.764-8.496 7.239-5.256h-8.948L11.721 0 8.948 8.505Z"
    />
  </svg>
);

const FourStars = () => (
  <svg width="128" height="24" viewBox="0 0 128 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0H24V24H0V0ZM26 0H50V24H26V0ZM52 0H76V24H52V0ZM78 0H102V24H78V0Z" fill="#00B67A" />
    <path d="M116 0H128V24H116V0Z" fill="#DCDCE6" />
    <path d="M104 0H116V24H104V0Z" fill="#DCDCE6" />
    <path
      d="M12 16.201L15.476 15.271L16.93 20L12 16.201ZM20 10.088H13.881L12 4L10.119 10.088H4L8.952 13.862L7.072 19.95L12.024 16.176L15.071 13.862L20 10.088ZM38 16.201L41.476 15.271L42.93 20L38 16.201ZM46 10.088H39.881L38 4L36.119 10.088H30L34.952 13.862L33.072 19.95L38.024 16.176L41.071 13.862L46 10.088ZM64.5 16.201L68.193 15.271L69.737 20L64.5 16.201ZM73 10.088H66.499L64.5 4L62.501 10.088H56L61.262 13.862L59.263 19.95L64.525 16.176L67.763 13.862L73 10.088ZM90.5 16.201L94.193 15.271L95.737 20L90.5 16.201ZM99 10.088H92.499L90.5 4L88.501 10.088H82L87.262 13.862L85.263 19.95L90.525 16.176L93.763 13.862L99 10.088ZM116.5 16.201L120.193 15.271L121.737 20L116.5 16.201ZM125 10.088H118.499L116.5 4L114.501 10.088H108L113.262 13.862L111.263 19.95L116.525 16.176L119.763 13.862L125 10.088Z"
      fill="white"
    />
  </svg>
);

const FourAndHalfStars = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 24">
    <path fill="#00B67A" d="M0 0h24v24H0V0Zm26 0h24v24H26V0Zm26 0h24v24H52V0Zm26 0h24v24H78V0Z" />
    <path fill="#DCDCE6" d="M116 0h12v24h-12V0Z" />
    <path fill="#00B67A" d="M104 0h12v24h-12V0Z" />
    <path
      fill="#fff"
      d="m12 16.201 3.476-.93L16.93 20 12 16.201Zm8-6.113h-6.119L12 4l-1.881 6.088H4l4.952 3.774-1.88 6.088 4.952-3.774 3.047-2.314L20 10.088Zm18 6.113 3.476-.93L42.93 20 38 16.201Zm8-6.113h-6.119L38 4l-1.881 6.088H30l4.952 3.774-1.88 6.088 4.952-3.774 3.047-2.314L46 10.088Zm18.5 6.113 3.693-.93L69.737 20 64.5 16.201Zm8.5-6.113h-6.501L64.5 4l-1.999 6.088H56l5.262 3.774-1.999 6.088 5.262-3.774 3.238-2.314L73 10.088Zm17.5 6.113 3.693-.93L95.737 20 90.5 16.201Zm8.5-6.113h-6.501L90.5 4l-1.999 6.088H82l5.262 3.774-1.999 6.088 5.262-3.774 3.238-2.314L99 10.088Zm17.5 6.113 3.693-.93L121.737 20l-5.237-3.799Zm8.5-6.113h-6.501L116.5 4l-1.999 6.088H108l5.262 3.774-1.999 6.088 5.262-3.774 3.238-2.314L125 10.088Z"
    />
  </svg>
);

const FiveStars = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 24">
    <path fill="#00B67A" d="M0 0h24v24H0V0Zm26 0h24v24H26V0Zm26 0h24v24H52V0Zm26 0h24v24H78V0Z" />
    <path fill="#DCDCE6" d="M116 0h12v24h-12V0Z" />
    <path fill="#00B67A" d="M104 0h24v24h-24V0Z" />
    <path
      fill="#fff"
      d="m12 16.201 3.476-.93L16.93 20 12 16.201Zm8-6.113h-6.119L12 4l-1.881 6.088H4l4.952 3.774-1.88 6.088 4.952-3.774 3.047-2.314L20 10.088Zm18 6.113 3.476-.93L42.93 20 38 16.201Zm8-6.113h-6.119L38 4l-1.881 6.088H30l4.952 3.774-1.88 6.088 4.952-3.774 3.047-2.314L46 10.088Zm18.5 6.113 3.693-.93L69.737 20 64.5 16.201Zm8.5-6.113h-6.501L64.5 4l-1.999 6.088H56l5.262 3.774-1.999 6.088 5.262-3.774 3.238-2.314L73 10.088Zm17.5 6.113 3.693-.93L95.737 20 90.5 16.201Zm8.5-6.113h-6.501L90.5 4l-1.999 6.088H82l5.262 3.774-1.999 6.088 5.262-3.774 3.238-2.314L99 10.088Zm17.5 6.113 3.693-.93L121.737 20l-5.237-3.799Zm8.5-6.113h-6.501L116.5 4l-1.999 6.088H108l5.262 3.774-1.999 6.088 5.262-3.774 3.238-2.314L125 10.088Z"
    />
  </svg>
);

export const TrustpilotStars: React.FC<TrustpilotStarsProps> = ({
  showReviewCount,
  rating,
  inverse,
  url,
  totalReviews = '5,900',
  ...rest
}) => {
  let StarsComponent;

  if (rating >= 4.0 && rating < 4.5) {
    StarsComponent = FourStars;
  } else if (rating >= 4.5 && rating < 5.0) {
    StarsComponent = FourAndHalfStars;
  } else if (rating === 5.0) {
    StarsComponent = FiveStars;
  } else {
    return null;
  }

  return (
    <StyledTrustpilotStars href={url} target="_blank" {...rest}>
      <Typography component="span" variant="titleExtraSmall" visuallyHidden>
        Trustpilot review {rating} stars.
      </Typography>
      <StyledLogo aria-hidden="true">
        <TrustPilotLogo inverse={inverse} />
        <StarsComponent />
      </StyledLogo>
      {showReviewCount && <>{totalReviews} + reviews</>}
    </StyledTrustpilotStars>
  );
};
